import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {MobileContainerBox} from "../boxes/mobile-container/mobile-container.box";
import {UserIconBox} from "../boxes/icon/user-icon.box";
import {UserBankrollBox} from "../boxes/bankroll/user-bankroll.box";
import {FreePlayDotIndicatorBox} from "../boxes/free-play-dot-indicator/free-play-dot-indicator.box";
import {CyClass} from "../../../../../../common/cy-classes";
import {
    TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE
} from "../../../../../services/tooltip/on-boarding-tooltip/on-boarding-tooltip-target-selectors";

export const HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent = observer(
    class HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent extends OrbitComponent {
        private _onClick = async () => {
            (await this.services.userMenu).openMenu();
        };

        private _renderFreePlayIndicator = () => {
            if(!this.services.freePlay.hasVouchers) {
                return null;
            }
            return (
                <FreePlayDotIndicatorBox className={CyClass('cy-free-play-indicator-dot')}/>
            )
        }

        render() {
            return (
                <MobileContainerBox onClick={this._onClick}
                                    className={TOOLTIP_TARGET_HEADER_BANKROLL_BUTTON_MOBILE}>
                    <UserIconBox/>
                    {this._renderFreePlayIndicator()}
                    <UserBankrollBox>
                        {this.services.currency.formatMoney(this.services.walletProxy.totalBankroll)}
                    </UserBankrollBox>
                </MobileContainerBox>
            );
        }
    }
);